import { render, staticRenderFns } from "./CompetitionHolderLive.vue?vue&type=template&id=2dd42544&"
import script from "./CompetitionHolderLive.vue?vue&type=script&lang=js&"
export * from "./CompetitionHolderLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports